import * as yup from 'yup';
import { ClientType } from '@packlink/packlink-sdk';

const TAX_ID_FORMAT_REGEXP = /^[a-zA-Z0-9]*$/;
function getPhonePrefixNumberValidation(t) {
  return yup.object().test('phone-invalid-required', '', function validatePhoneNumber(value) {
    var _value$prefix, _value$number, _value$number2;
    if (!(value !== null && value !== void 0 && value.number) || !((_value$prefix = value.prefix) !== null && _value$prefix !== void 0 && _value$prefix.alpha2Code)) {
      return this.createError({
        path: this.path,
        message: t('invoice-form.error.required', {
          field: t('invoice-form.label.phone')
        })
      });
    }
    if (((_value$number = value.number) === null || _value$number === void 0 ? void 0 : _value$number.length) < 8) {
      return this.createError({
        path: this.path,
        message: t('invoice-form.error.min', {
          field: t('invoice-form.label.phone'),
          number: 8
        })
      });
    }
    if (((_value$number2 = value.number) === null || _value$number2 === void 0 ? void 0 : _value$number2.length) >= 17) {
      return this.createError({
        path: this.path,
        message: t('invoice-form.error.max', {
          field: t('invoice-form.label.phone'),
          number: 18
        })
      });
    }
    if (!/^[\d+]+$/g.test(value.number)) {
      return this.createError({
        path: this.path,
        message: t('invoice-form.error.phone')
      });
    }
    return true;
  });
}
const getInvoiceValidation = (t, clientType, showDefaultPhoneInput) => {
  const isAutonomous = clientType === ClientType.AUTONOMOUS;
  const isBusiness = clientType === ClientType.BUSINESS;
  const autonomousSchema = {
    firstName: yup.string().trim().max(50, t('invoice-form.error.max', {
      field: t('invoice-form.label.first-name'),
      number: 50
    })).required(t('invoice-form.error.required', {
      field: t('invoice-form.label.first-name')
    })),
    lastName: yup.string().trim().max(50, t('invoice-form.error.max', {
      field: t('invoice-form.label.last-name'),
      number: 50
    })).required(t('invoice-form.error.required', {
      field: t('invoice-form.label.last-name')
    }))
  };
  const companySchema = {
    companyName: yup.string().trim().max(50, t('invoice-form.error.max', {
      field: t('invoice-form.label.company-name'),
      number: 50
    })).required(t('invoice-form.error.required', {
      field: t('invoice-form.label.company-name')
    })),
    taxId: yup.string().max(50, t('invoice-form.error.max', {
      field: t('invoice-form.label.tax-id'),
      number: 50
    })).required(t('invoice-form.error.required', {
      field: t('invoice-form.label.tax-id')
    })).matches(TAX_ID_FORMAT_REGEXP, t('invoice-form.error.tax-id'))
  };
  const defaultPhoneSchema = yup.string().trim().min(8, t('invoice-form.error.min', {
    field: t('invoice-form.label.phone'),
    number: 8
  })).max(18, t('invoice-form.error.max', {
    field: t('invoice-form.label.phone'),
    number: 18
  })).matches(/^[^a-zA-Z]+$/, t('invoice-form.error.phone')).required(t('invoice-form.error.required', {
    field: t('invoice-form.label.phone')
  }));
  const phoneWithPrefixSchema = getPhonePrefixNumberValidation(t);
  return yup.object().shape({
    ...(isAutonomous && autonomousSchema),
    ...(isBusiness && companySchema),
    phone: yup.lazy(value => typeof value === 'string' && showDefaultPhoneInput ? defaultPhoneSchema : phoneWithPrefixSchema),
    email: yup.string().trim().email(t('invoice-form.error.format', {
      field: t('invoice-form.label.email')
    })).max(50, t('invoice-form.error.max', {
      field: t('invoice-form.label.email'),
      number: 50
    })).required(t('invoice-form.error.required', {
      field: t('invoice-form.label.email')
    })),
    address: yup.string().trim().max(80, t('invoice-form.error.max', {
      field: t('invoice-form.label.address'),
      number: 80
    })).required(t('invoice-form.error.required', {
      field: t('invoice-form.label.address')
    })),
    country: yup.mixed().required(t('invoice-form.error.required', {
      field: t('invoice-form.label.country')
    })),
    postalCode: yup.mixed().required(t('invoice-form.error.required', {
      field: t('address-selectors.postal-code.label')
    }))
  }).defined();
};

export { getInvoiceValidation, getPhonePrefixNumberValidation };
//# sourceMappingURL=InvoiceFormValidations.js.map
